<template>
  <div class="f-shareCampaignModal">
    <b-modal id="shareCampaignModal"
             ref="shareCampaignModal"
             centered
             size="lg"
             hide-footer
             :title="modalTitle">
      <p class="my-4">
        Here will appear some images about the chart to be shared.
      </p>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'ShareCampaignModal',
    data () {
      return {
        headerClass: 'modal-header-class'
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      modalTitle () {
        return this.activeLanguage.share + ' ' + this.activeLanguage.ourCampaign
      }
    },
    methods: {
      showModal () {
        this.$refs.shareCampaignModal.show()
      },
      hideModal () {
        this.$refs.shareCampaignModal.hide()
      }
    },
    mounted () {
      document.getElementById('shareCampaignModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
      document.getElementById('shareCampaignModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
    }
  }
</script>

<style scoped>
  .modal-header-style {
    background-color: #c41c21 !important;
    color: white !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/cartaAlpFoodWay/ShareCampaignModal.vue